export const CREDITS_TO_DOLLARS_RATIO = 4;

export const FREE_PLAN = {
    benefits: [
        "User and project secrets",
        "Up to 3 parallel environments",
        "Sandboxed Ona Environments with 4 cores, 16G RAM, 80GB disk",
        "Ona Agent with Claude 4.5 Sonnet",
        "Professional edit/review with VS Code Web",
        "One-click transition to desktop IDE",
        "Work from any device",
        "devcontainer.json and automations.yml support",
        "Environments auto-delete after 1 day of inactivity",
    ],
} as const;
export const ENTERPRISE_PLAN = {
    benefits: [
        "Bank-grade VPC deployment",
        "Private LLM access through AWS Bedrock, Google Vertex, Anthropic or custom gateways",
        "Complete network control",
        "Fine grained roles, permissions and policies (incl. MCP usage)",
        "SSO and OIDC identity and access controls",
        "Org-wide secrets",
        "Audit logs",
        "Org-wide engineering productivity insights",
        "Uptime guarantees (SLAs)",
        "Dedicated support and forward deployed engineer",
    ],
} as const;

const CORE_PLAN_MONTHLY_PRICE_USD = 20;

export const CORE_PLAN_AMOUNT_OPTIONS = [
    { amountUsd: 20, label: "80 OCUs" },
    { amountUsd: 50, label: "200 OCUs" },
    { amountUsd: 100, label: "400 OCUs" },
    { amountUsd: 200, label: "800 OCUs" },
    { amountUsd: 500, label: "2000 OCUs + 200 OCUs bonus" },
] as const;

export const CORE_PLAN = {
    monthlyPriceUsd: CORE_PLAN_MONTHLY_PRICE_USD,
    creditsPerMonth: CORE_PLAN_MONTHLY_PRICE_USD * CREDITS_TO_DOLLARS_RATIO,
    amountOptions: CORE_PLAN_AMOUNT_OPTIONS,
    benefits: [
        "Up to 100 team members",
        "Unlimited parallel environments",
        "Up to 32 cores, 128G RAM, 200G disk",
        "GPU Support",
        "Environment lifecycle management",
        "Project sharing and collaboration",
        "Role based access management",
        "Custom org-wide commands and deny lists",
        "Basic support",
        "Environments auto-delete after 7 days of inactivity",
    ],
} as const;
